
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CloseIcon from '@mui/icons-material/Close';
import { Avatar, Box, ButtonGroup, Fab, IconButton, MenuItem, Paper, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi, postSaveObjectApi, putUpdateObjectApi, putUpdateObjectListByPropertyValueArrayApi } from 'api/general';
import { getMeetingPreviousUsersFromUnitIdApi } from 'api/meeting';
import LoadingPopUp from 'app/components/LoadingPopup';
import { getUserFullName, highlightText, sortByProperty, sortedMembers, swal_error } from 'app/utils/appHelpers';
import { MEETING_USER } from 'app/utils/constants/customConstant';
import { updateMeetingAfterUserOperation } from 'app/utils/meetingReduxHelpers';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import config from '../../../../config';
import UserParticipantDataTableToolbar from './UserParticipantDataTableToolbar';

function MeetingMemberDataTable({
  column,
  handleDeleteUser,
  selectedMemberRole,
  setSelectedMemberRole,
  selectedActing,
  setSelectedActing,
  componentType,
  updateRedux, updateReduxFlag, setUpdateReduxFlag, sortingRequired, setSortingRequired }) {

  const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
  const currentMeetingUsers = useSelector((state) => state.meeting.currentMeetingUsers);
  const currentMeetingParticipants = useSelector((state) => state.meeting.currentMeetingParticipants);

  const authUser = useSelector(state => state.auth.authUser);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [highlightQuery, setHighlightQuery] = useState('');
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [previousUserButtonClick, setPreviousUserButtonClick] = useState(false);
  const [titleSortingStatus, setTitleSortingStatus] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(false);
  const { data: userList, isLoading: userLoading } = useSelector(state => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (updateReduxFlag) {

      let sortedData = [];
      if (componentType === "user") {
        sortedData = currentMeetingUsers;
        sortedData = sortByProperty(sortedData, "indexNo");
        setData(sortedData);
        setData2(sortedData);
      } else if (componentType === "participant") {
        sortedData = currentMeetingParticipants;
        sortedData = sortByProperty(sortedData, "indexNo");
        setData(sortedData);
        setData2(sortedData);
      }
      setUpdateReduxFlag(false);
    }
  }, [componentType, updateReduxFlag]);

  useEffect(() => {
    updateRedux(data)
  }, [data]);

  useEffect(() => {
    if (titleSortingStatus) {
      const getAPI = async () => {
        if (data !== undefined && data.length > 0) {
          const sortedMemberList = sortedMembers(data);
          sortingAfterData([...sortedMemberList])
        }
        setTitleSortingStatus(false);
      }
      getAPI();
    }
  }, [titleSortingStatus]);

  useEffect(() => {
    if (sortingRequired) {
      const sortData = async () => {
        await sortingAfterData([...data]);
      };

      sortData();
      setSortingRequired(false);
    }
  }, [sortingRequired]);

  function filterByComponentType(list) {
    if (componentType === "user") {
      list = list.filter(x => x.type === Number(1));
    } else if (componentType === "participant") {
      list = list.filter(x => x.type === Number(2));
    }
    return list;
  }

  const addMemberList = async (users) => {
    try {
      const res = await getObjectListByPropertyApi(MEETING_USER, "meetingId", currentMeeting.id)
      let list = res.data;
      list = filterByComponentType(list);
      for (let i = 0; i < list.length; i++) {
        await deleteObjectApi(MEETING_USER, list[i].id);
      }

      // attendanceStatus değeri 0 olanları 1 yap
      for (let i = 0; i < users.length; i++) {
        if (users[i].attendanceStatus === 0 || users[i].attendanceStatus === undefined) {
          users[i].attendanceStatus = 1;
        }
        users[i].meetingId = currentMeeting.id;
        delete users[i].id;
        const result = await postSaveObjectApi(MEETING_USER, users[i])
        users[i].id = result.data.insertId;
      }

      if (users.length > 0) {
        await updateMeetingAfterUserOperation(
          currentMeeting,
          authUser,
          dispatch
        );
      }

      users.forEach(element => {
        const user = userList.find(item => item.id === element.userId);
        element.user = user;
      });
      return users;
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    if (!previousUserButtonClick) return;

    (async () => {
      try {
        if (currentMeeting.meetingNo <= 1) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: "Bu kol/komisyon/kurulun ilk toplantısı olduğu için önceki üyeleri bulunmamaktadır.",
            showConfirmButton: false,
            timer: 2000,
            customClass: {
              container: 'swal-container-custom'
            },
          });

          return;
        }

        const list = await getMeetingPreviousUsersFromUnitIdApi(
          currentMeeting.unitId,
          currentMeeting.meetingNo
        );
        console.log("list", list);
        const filtered = filterByComponentType(list);
        console.log("filtered", filtered);
        const enriched = await addMemberList(filtered);
        console.log("enriched", enriched);
        if (!enriched || enriched.length === 0) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Önceki üyeler bulunamadı.',
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              container: 'swal-container-custom'
            },
          });
        } else {
          setData(enriched);
          setData2(enriched);
        }
      } catch (err) {
        console.error(err);
        swal_error("Sunucu hatası: " + err.message);
      } finally {
        setPreviousUserButtonClick(false);
      }
    })();
  }, [
    previousUserButtonClick
  ]);

  const handleSelectChange = async (e, member) => {

    const updatedMember = { id: member.id, [e.target.name]: e.target.value };
    const result = await putUpdateObjectApi(MEETING_USER, updatedMember)

    if (result.status) {
      if (e.target.name === 'memberRole') {
        setSelectedMemberRole((prevState) => ({
          ...prevState,
          [member.id]: e.target.value
        }));
      } else if (e.target.name === 'acting') {
        setSelectedActing((prevState) => ({
          ...prevState,
          [member.id]: e.target.value
        }));
      }

      setData(prevData =>
        prevData.map(item =>
          item.id === member.id
            ? { ...item, [e.target.name]: e.target.value }
            : item
        )
      );
      if (authUser.id !== currentMeeting.adminUserId) {
        await updateMeetingAfterUserOperation(
          currentMeeting,
          authUser,
          dispatch
        );
      }
    }
  };

  const sortingArray = (index, row, direction) => {
    let rowsNew = [...data];
    if (direction === 'up') {
      const tmp = rowsNew[index - 1];
      rowsNew[index - 1] = row;
      rowsNew[index] = tmp;
    } else {
      const tmp = rowsNew[index + 1];
      rowsNew[index + 1] = row;
      rowsNew[index] = tmp;
    }
    setData([...rowsNew]);
    setData2([...rowsNew]);
    sortingAfterData(rowsNew)

  }

  const sortingAfterData = async (sortedData) => {
    sortedData = sortedData.map((item, idx) => ({
      ...item,
      indexNo: idx + 1,
    }));

    const objectList = sortedData.map(({ id, indexNo }) => ({ id, indexNo }));
    const result = await putUpdateObjectListByPropertyValueArrayApi(MEETING_USER, "indexNo", objectList);
    if (result.status) {
      setData([...sortedData]);
      setData2([...sortedData]);

      if (authUser.id !== currentMeeting.adminUserId) {
        await updateMeetingAfterUserOperation(
          currentMeeting,
          authUser,
          dispatch
        );
      }

    }
  };

  const DataTableHead = ({ onRequestSort, customColumnData }) => {

    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {customColumnData.map(column => {
            return (
              <TableCell
                key={column.id}
                align={column.numeric}
                padding={column.disablePadding ? 'none' : 'normal'}
                sx={{ whiteSpace: 'normal' }}
              >
                <Tooltip
                  title="Sırala"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={createSortHandler(column.id)}
                    sx={{ whiteSpace: 'normal', '& .MuiTableSortLabel-icon': { flexShrink: 0 } }}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  };

  const instList = currentMeeting.inst !== "YK"
    ? [...config.institutions.map(x => x.inst)]
    : [...config.institutions.map(x => x.inst), "Yönetim Kurulu Üyesi"];

  return (

    <Paper className="col-md-12" sx={{ minWidth: 0, overflow: 'hidden' }}>
      <UserParticipantDataTableToolbar
        componentType={componentType}
        setPreviousUserButtonClick={setPreviousUserButtonClick}
        setTitleSortingStatus={setTitleSortingStatus}
        pageTitle={componentType === "user" ? "Üyeler" : "Katılımcılar"}
        data2={data2}
        setData={setData}
        setHighlightQuery={setHighlightQuery}
      />

      <div className="flex-auto" style={{ minWidth: 0 }}>
        <Box sx={{ overflowX: 'auto' }}>
          <Table
            size="small"
            sx={{
              minWidth: 960,
              '& .MuiTableCell-head': { whiteSpace: 'normal' },
              '& .MuiTableSortLabel-root': { whiteSpace: 'normal' },
              '& .MuiTableSortLabel-icon': { flexShrink: 0 },
            }}
          >
            <DataTableHead
              order={order}
              orderBy={orderBy}
              rowCount={data.length}
              customColumnData={column}
            />
            {loadingProgress && <LoadingPopUp open={loadingProgress} />}
            <TableBody>
              {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((n, idx) => {

                // const user = userList.find(x => x.id === n.userId);

                const user = n.user || userList.find(x => Number(x.id) === Number(n.userId))

                return (
                  <TableRow hover key={"trO" + n.id} sx={{  }}>
                    <TableCell align="left" padding="normal" sx={{  }}>
                      <ButtonGroup>
                        <IconButton onClick={() => sortingArray(idx, n, 'up')} disabled={idx === 0}>
                          <ArrowUpwardIcon sx={{  }} />
                        </IconButton>
                        <IconButton onClick={() => sortingArray(idx, n, 'down')} disabled={idx === data.length - 1}>
                          <ArrowDownwardIcon sx={{  }} />
                        </IconButton>
                      </ButtonGroup>
                    </TableCell>

                    <TableCell align="left" padding="left" sx={{ display: 'flex', alignItems: 'center', height: '50px' }}>
                      <Avatar
                        alt={user ? user.name : ""}
                        src={
                          user && user.profileImageUrl
                            ? `${config.userAuthApiUrl}${user.profileImageUrl}`
                            : undefined
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl;
                        }}
                        sx={{ marginRight: '10px', flexShrink: 0 }}
                      />
                      {highlightText(getUserFullName(user), highlightQuery)}
                    </TableCell>

                    {componentType !== undefined && componentType === "user" ? (
                      <>

                        <TableCell align="left" padding="1px" sx={{  }}>
                          <Select
                            name="inst"
                            size="small"
                            value={n.inst}
                            onChange={(e) => handleSelectChange(e, n)}
                            sx={{  }}
                          >
                            {(instList).map((item, index) => (
                              <MenuItem key={index} value={item} sx={{  }}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>

                        <TableCell align="left" padding="1px" sx={{  }}>
                          <Select
                            name="memberRole"
                            size="small"
                            value={selectedMemberRole[n.id] || n.memberRole}
                            onChange={(e) => handleSelectChange(e, n)}
                            sx={{  }}
                          >
                            {(config.meetingMemberRoles || []).map((item, index) => (
                              <MenuItem key={index} value={item} sx={{  }}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>

                        <TableCell align="left" padding="none" sx={{  }}>
                          <Select
                            size="small"
                            name="acting"
                            value={selectedActing[n.id] || n.acting}
                            onChange={(e) => handleSelectChange(e, n)}
                            sx={{  }}
                          >
                            {(config.meetingActing || []).map((item, index) => (
                              <MenuItem key={index} value={item} sx={{  }}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>
                      </>
                    ) :

                      <TableCell align="left" padding="none" sx={{  }}>
                        <p>Kurum Personeli</p>
                      </TableCell>

                    }

                    <TableCell align="left" padding="4px" sx={{  }}>
                      <Fab

                        aria-label="Delete"
                        onClick={() => {
                          handleDeleteUser(n);
                        }}
                      >
                        <CloseIcon />
                      </Fab>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow sx={{  }}>
                <TablePagination
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(e, page) => setPage(page)}
                  onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                  labelRowsPerPage={"Görüntülenecek Satır"}
                  rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                  showFirstButton
                  showLastButton
                  sx={{  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Box>
      </div>
    </Paper >

  );
};
const style = document.createElement('style');
style.innerHTML = `
    .swal-container-custom {
        z-index: 10000 !important;
    }
`;
document.head.appendChild(style);
export default MeetingMemberDataTable;